import currency from 'currency.js';

const EURO = (value: string | number) => currency(value, { symbol: '€', decimal: ',', separator: '.' });

export const formatCurrency = (amount: number | string): string => EURO(amount).format();

export const addDecimalToString = (stringValue: string, newValue: number): number => EURO(stringValue).add(newValue).value;

export const convertCurrencyToNumber = (amount: string): number => EURO(amount).value;